RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const config = [
        [
            {
                name: 'top-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'top-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        [
            {
                name: 'middle-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'middle-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        [
            {
                name: 'bottom-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            },
            {
                name: 'bottom-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            }
        ],
        {
            name: 'bottom',
            sizes: {
                md: 12
            },
            page: 1
        }
    ];

    const Dashboard = RivalIQ.apps.Dashboard;
    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'additional-auth-instagram',
            widgetId: RivalIQ.enums.widgetTypes.ADDITIONAL_AUTHORIZATION,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: RivalIQ.enums.sources.INSTAGRAM_INSIGHTS
            }
        },
        {
            instanceId: 'followers',
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_FOLLOWERS,
            region: 'top-left',
            props: {
                metrics: [
                    {
                        property: 'followers_count',
                        channel: RivalIQ.enums.channels.INSTAGRAM,
                        dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        useIntervalDomainFormatting: true
                    }
                ]
            }
        },
        {
            instanceId: 'profile-analytics',
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_PROFILE_ANALYTICS,
            region: 'top-right'
        },
        {
            instanceId: 'reach',
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_REACH,
            region: 'middle-left'
        },
        {
            instanceId: 'impressions',
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_IMPRESSIONS,
            region: 'middle-right'
        },
        {
            instanceId: 'follower-age-gender',
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_FOLLOWER_AGE_GENDER,
            region: 'bottom-left'
        },
        {
            instanceId: 'follower-locations',
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_FOLLOWER_LOCATIONS,
            region: 'bottom-right'
        },
        {
            instanceId: 'follower-online-times',
            widgetId: widgetTypes.INSTAGRAM_INSIGHTS_FOLLOWER_ONLINE_TIMES,
            region: 'bottom'
        }
    ];

    const InstagramInsightsLayout = Dashboard.views.CurationLayout.extend({
        config: config
    });

    const ExportLayout = Dashboard.views.ExportWidgets.extend({
        childView: Dashboard.views.ExportLayout.extend({
            config: config
        })
    });

    curations.InstagramInsightsCuration = curations._BaseInstagramInsightsCuration.extend({

        widgetsView: InstagramInsightsLayout,
        exportWidgetsView: ExportLayout,
        beforeFilters: curations._BaseInstagramInsightsCuration.prototype.beforeFilters.concat(curations.filters.getInstagramInsightsBoostedPostsStatus),

        exportTitle: 'Instagram Insights',

        buildConfiguration: function () {
            const definitions = widgets;

            return new RivalIQ.apps.Dashboard.models.Configuration({
                props: {
                    source: RivalIQ.enums.sources.INSTAGRAM_INSIGHTS,
                    channel: RivalIQ.enums.channels.INSTAGRAM
                },
                definitions: definitions
            });
        }
    });
});
